import { Dispatch, GetState } from "common/types";

import { getClient } from "services";

import { fetchEnrolledClassesIfNotFetched } from "seneca-common/features/enrollments/features/class-enrollments/service/actions";
import { getEnrolledClassesWithCourse } from "seneca-common/features/enrollments/features/class-enrollments/state";
import { getCachedSelectedSchool } from "seneca-common/features/schools/school-selection/queries";

import {
  fetchClassLeaderboardActionFactory,
  receiveClassLeaderboard
} from "../state";

const getClassLeaderboardServiceClient = () =>
  getClient("classLeaderboardsService");

export const fetchClassLeaderboard = (classId: string) =>
  fetchClassLeaderboardActionFactory({
    requestFunction: classId =>
      getClassLeaderboardServiceClient().fetchLeaderboardForStudent(classId),
    storeAction: receiveClassLeaderboard
  })(classId, classId);

export const fetchClassLeaderboardsForCourse =
  (courseId: string) => async (dispatch: Dispatch, getState: GetState) => {
    const school = getCachedSelectedSchool();

    await dispatch(
      fetchEnrolledClassesIfNotFetched({ schoolId: school?.schoolId })
    );
    const classIds = getEnrolledClassesWithCourse(courseId)(getState()).map(
      enrollment => enrollment.classId
    );

    classIds.forEach(classId => dispatch(fetchClassLeaderboard(classId)));
  };
